import { VyRadioCardLabel } from '../../../../../../../components/new-design/inputs/VyRadio';
import type { PlanSelectionOption } from './plan-selection-dialog-types';

export const PLAN_SELECTION_OPTIONS = [
  {
    value: 'existing' as PlanSelectionOption,
    label: (
      <VyRadioCardLabel
        title="Select from existing"
        description="Select an existing contract from your templates list"
      />
    ),
  },
  {
    value: 'new' as PlanSelectionOption,
    label: (
      <VyRadioCardLabel
        title="Create a new contract"
        description="Build a dedicated pricing plan to your customer"
      />
    ),
  },
];

export const TEMPLATE_SELECT_FIELD_SX = {
  height: '50px',
  borderRadius: '8px',
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    height: '50px',
    padding: '8px 12px',
    paddingBottom: '8px !important',
    backgroundColor: 'rgba(13, 27, 39, 0.04) !important',
  },
  '& .MuiOutlinedInput-root': {
    height: '50px',
  },
} as const;
